import StateBase from "./StateBase.js";
const registry = /* @__PURE__ */ new Map();
const registerStmState = (name, state) => {
  registry.set(name, state);
};
const resolveStmState = (state) => {
  if (typeof state === "string") {
    state = registry.get(state);
  }
  return state;
};
var Registry_default = {
  registerStmState,
  resolveStmState
};
export {
  Registry_default as default,
  registerStmState,
  resolveStmState
};
